import { render, staticRenderFns } from "./StylingServices.vue?vue&type=template&id=1d37566d&scoped=true&"
import script from "./StylingServices.vue?vue&type=script&lang=js&"
export * from "./StylingServices.vue?vue&type=script&lang=js&"
import style0 from "./StylingServices.vue?vue&type=style&index=0&id=1d37566d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d37566d",
  null
  
)

export default component.exports